// src/components/Footer.js
import { useState, useEffect } from "react";
// import logo from "../assets/logo.png"; // adjust path
import { FaInstagram, FaFacebookF, FaLinkedinIn, FaTiktok } from "react-icons/fa";
import { FaXTwitter, FaYoutube } from "react-icons/fa6";
import logo from "../../assets/images/logo.png";
import ahead1 from "../../assets/images/aheadnew1.png";
import ahead2 from "../../assets/images/aheadnew2.png";
import ahead3 from "../../assets/images/aheadnew3.png";
import ahead4 from "../../assets/images/aheadnew4.png";
import chat from "../../assets/images/chat.png";
import chat2 from "../../assets/images/chat2.png";
import { motion, AnimatePresence } from "framer-motion";
import { useLocation, useNavigate } from "react-router-dom";
import { useGeneral } from "../contexts/GeneralContext";
export default function Footer() {
  const navigate = useNavigate();
  const { extraContent } = useGeneral();
  const [state, setState] = useState({
    scrolled: false,
    active: "",
  });
  const location = useLocation();
  const images = [ahead2, ahead3, ahead4];
  const [current, setCurrent] = useState(0);
  const [hovered, setHovered] = useState(false);

  useEffect(() => {
    if (!hovered) return;

    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % images.length);
    }, 800); // change image every 0.8s

    return () => clearInterval(interval);
  }, [hovered]);
  useEffect(() => {
    const path = location.pathname.replace("/", "");
    const query = new URLSearchParams(location.search);
    const activeQuery = query.get("active"); // e.g., "who"
    if (!path) {
      setState((prev) => ({ ...prev, active: "Home" }));
    } else if (path === "about" && activeQuery) {
      setState((prev) => ({ ...prev, active: activeQuery }));
    } else {
      setState((prev) => ({ ...prev, active: path }));
    }
  }, [location.pathname, location.search]);
useEffect(() => {
  const isMobile = window.innerWidth <= 768; // you can adjust breakpoint
  
  const handleScroll = () => {
    setState(prev => ({
      ...prev,
      scrolled: window.scrollY > (isMobile ? 100 : 50),
    }));
  };

  let timeoutId;

  const debouncedHandleScroll = () => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(handleScroll, 10); // debounce
  };

  window.addEventListener("scroll", debouncedHandleScroll);

  return () => {
    window.removeEventListener("scroll", debouncedHandleScroll);
    clearTimeout(timeoutId);
  };
}, []);

  const iconMap = {
    facebook: FaFacebookF,
    twitter: FaXTwitter,
    linkedin: FaLinkedinIn,
    youtube: FaYoutube,
    instagram: FaInstagram,
    tiktok: FaTiktok,
  };

  return (
    <>
      <footer
        className={`w-full relative z-[30] bg-[#f0f2f0] px-0 py-10 2.5xl:py-14 xl:px-12 1xl:px-[50pt] 2.5xl:px-24 rounded-[15px] max-h-[258px]  ${
          state.scrolled ? "py-4 md:py-10" : "py-4 lg:py-12"
        }`}
      >
        <div className="grid  grid-cols-1 xl:grid-cols-[0.7fr_4fr_0.7fr] 1xl:grid-cols-[0.7fr_2.5fr_1.2fr] 2.5xl:grid-cols-[0.7fr_2fr_0.7fr] items-center gap-0 xl:gap-8 1xl:gap-10 ">
          {/* Left Column - Logo */}
          <div
            className={` h-full flex justify-center xl:justify-start  1xl:items-center 1xl:justify-start   cursor-pointer ${
              state.scrolled ? "hidden xl:flex" : ""
            }`}
            onClick={() => {
              navigate(`/`);
            }}
          >
            <img
              src={logo}
              alt="Nutricub Logo"
              className="h-auto 2.5xl:w-[206px] 1xl:w-[156px] lg:w-[126px] w-[206px] object-contain"
              title="View home page"
            />
          </div>

          {/* Middle Column (takes 2 cols) with 5 sub-columns */}
          <div className=" xl:grid justify-start ">
            <div className="  grid grid-cols-1 xl:gap-3 2.5xl:gap-20  xl:grid-cols-[1fr_1fr_2.2fr_1.7fr]  1xl:grid-cols-[1fr_1fr_1.7fr_1.4fr] 2.5xl:grid-cols-[1.1fr_0.9fr_1.9fr_2fr]   w-full text-left items-start">
              {/* Packages */}
              <div className="hidden xl:grid">
                <ul className="space-y-1 text-sm  text-gray-700">
                  <li
                   className={`hover:text-orange cursor-pointer 2.5xl:text-21pt  xl:text-lg lg:text-base  mb-1  ${
                      state.active.toLocaleLowerCase() === "plans"
                        ? "text-orange"
                        : "text-secondary"
                    }`}
                    onClick={() => {
                      navigate(`/plans`);
                    }}
                  >
                    Plans
                  </li>
                  <li
                   className={`hover:text-orange cursor-pointer 2.5xl:text-21pt  xl:text-lg lg:text-base  mb-1  ${
                      state.active.toLocaleLowerCase() === "meals"
                        ? "text-orange"
                        : "text-secondary"
                    }`}
                    onClick={() => {
                      navigate(`/meals`);
                    }}
                  >
                    Meals
                  </li>
                  <li
                    className={`hover:text-orange cursor-pointer 2.5xl:text-21pt  xl:text-lg lg:text-base  mb-1  ${
                      state.active.toLocaleLowerCase() === "shop"
                        ? "text-orange"
                        : "text-secondary"
                    }`}
                    onClick={() => {
                      navigate(`/shop`);
                    }}
                  >
                    Shop
                  </li>
                  <li
                    className={` hover:text-orange cursor-pointer 2.5xl:text-21pt  xl:text-lg lg:text-base  mb-1 ${
                      state.active.toLocaleLowerCase() === "careers"
                        ? "text-orange"
                        : "text-secondary"
                    }`}
                    onClick={() => {
                      navigate(`/careers`);
                    }}
                  >
                    Careers
                  </li>
                </ul>
              </div>

              {/* About */}
              <div className="hidden xl:grid max-w-[150px]">
                <ul className="space-y-1 text-sm font-mono text-gray-700">
                  <li
                    className={`text-secondary font-sans hover:text-orange cursor-pointer 2.5xl:text-21pt  xl:text-lg lg:text-base   mb-2 ${
                      state.active === "who" ||
                      state.active === "what" ||
                      state.active === "why"
                        ? "text-orange"
                        : "text-secondary"
                    }`}
                    onClick={() => navigate("/about")}
                  >
                    About
                  </li>
                  <li
                    className={`hover:font-sans cursor-pointer transition-all duration-300 ease-in-out ${
                      state.active === "who" ? "font-sans" : ""
                    }`}
                    onClick={() =>
                      navigate("/about?active=who&scroll=1", { replace: true })
                    }
                  >
                    Who we are
                  </li>
                  <li
                    className={`hover:font-sans cursor-pointer transition-all duration-300 ease-in-out ${
                      state.active === "what" ? "font-sans" : ""
                    }`}
                    onClick={() =>
                      navigate("/about?active=what&scroll=1", { replace: true })
                    }
                  >
                    What we do
                  </li>
                  <li
                    className={`hover:font-sans cursor-pointer transition-all duration-300 ease-in-out ${
                      state.active === "why" ? "font-sans" : ""
                    }`}
                    onClick={() =>
                      navigate("/about?active=why&scroll=1", { replace: true })
                    }
                  >
                    Why us
                  </li>
                </ul>
              </div>

              {/* Media zone */}
              <div className="hidden xl:grid">
                <h4
                  className={`hover:text-orange cursor-pointer 2.5xl:text-21pt  xl:text-lg lg:text-base  mb-2 transition-all duration-300 ease-in-out ${
                    state.active === "news-events"
                      ? "text-orange"
                      : "text-secondary"
                  }`}
                  onClick={() => navigate("/news-events")}
                >
                  News & Events
                </h4>
                <h4
                  className={`hover:text-orange cursor-pointer 2.5xl:text-21pt  xl:text-lg lg:text-base  mb-2 transition-all duration-300 ease-in-out ${
                    state.active === "terms" ? "text-orange" : "text-secondary"
                  }`}
                  onClick={() => navigate("/terms")}
                >
                  Terms & Conditions
                </h4>
                <h4
                  className={`hover:text-orange cursor-pointer 2.5xl:text-21pt  xl:text-lg lg:text-base  mb-2 transition-all duration-300 ease-in-out ${
                    state.active === "reviews"
                      ? "text-orange"
                      : "text-secondary"
                  }`}
                  onClick={() => navigate("/reviews")}
                >
                  Reviews
                </h4>
              </div>
              {/* Support / Legal */}
              <div className="hidden xl:grid">
                <ul className=" text-sm  text-gray-700">
                  <li
                    className={`hover:text-orange cursor-pointer 2.5xl:text-21pt  xl:text-lg lg:text-base mb-2   transition-all duration-300 ease-in-out ${
                      state.active === "contact"
                        ? "text-orange"
                        : "text-secondary"
                    }`}
                    onClick={() => navigate("/contact")}
                  >
                    Contact Us
                  </li>
                  {/* <li className="text-secondary hover:text-orange cursor-pointer    lg:text-base xl:text-lg  2.5xl:text-21pt mb-2">
                    Customer support
                  </li> */}
                  <li
                    className={`hover:text-orange cursor-pointer 2.5xl:text-21pt  xl:text-lg lg:text-base  mb-2  transition-all duration-300 ease-in-out ${
                      state.active === "school-nursery"
                        ? "text-orange"
                        : "text-secondary"
                    }`}
                    onClick={() => navigate("/school-nursery")}
                  >
                    Schools/Nurseries
                  </li>
                  <li
                    className={`hover:text-orange cursor-pointer 2.5xl:text-21pt  xl:text-lg lg:text-base mb-2  transition-all duration-300 ease-in-out ${
                      state.active === "party-catering"
                        ? "text-orange"
                        : "text-secondary"
                    }`}
                    onClick={() => navigate("/party-catering")}
                  >
                    Party Catering
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div
            className={` flex flex-col h-full  items-center justify-center xl:items-start lg:justify-center  2.5xl:-ms-3 gap-3  relative ${
              state.scrolled ? "mt-0" : "pt-2 xl:mt-0"
            }`}
          >
            {/* Social icons */}
            <div className="flex gap-3 2.5xl:gap-4 text-gray-500 text-xl ">
              {extraContent?.socialChannels.map((channel) => {
                const IconComponent = iconMap[channel.name];
                if (!IconComponent || !channel?.value) return null; // skip if no icon defined
                return (
                  <a
                    key={channel.name}
                    href={channel.value}
                    target="_blank"
                    rel="noopener noreferrer"
                    title={`View ${channel.name}`}
                    className="w-[44px] h-[44px] lg:w-[35px] lg:h-[35px] 2xl:w-[44px] 2xl:h-[44px] bg-gray text-white/60 hover:bg-green hover:text-white cursor-pointer rounded-full flex items-center justify-center"
                  >
                    <IconComponent className=" text-28pt lg:text-[22px] 2xl:text-28pt" />
                  </a>
                );
              })}
            </div>

            {/* Floating Chat Button */}
            {extraContent?.whatsAppNumber && (
              <div
                className="hidden xl:grid fixed z-[100] cursor-pointer chatIcon  group"
                onClick={() =>
                  window.open(
                    `https://wa.me/${extraContent?.whatsAppNumber}?text=Hello`,
                    "_blank"
                  )
                }
              >
                {/* Default image */}
                <img
                  src={chat}
                  title="Chat with us"
                  className="group-hover:hidden w-[100px] h-[100px] 2xl:w-[140px] 2xl:h-[140px]"
                />

                {/* Hover image */}
                <img
                  src={chat2} // <-- replace with your hover image path
                  width={140}
                  height={140}
                  title="Chat with us"
                  className="hidden group-hover:block w-[100px] h-[100px] 2xl:w-[140px] 2xl:h-[140px]"
                />
              </div>
            )}
          </div>

          {/* Right Column - Social + Chat */}
        </div>
      </footer>

      <div className="w-full text-sm font-mono flex text-center items-center justify-center mt-2 text-green">
        © {new Date().getFullYear()} NutriCub,{" "}
        <a
          href="https://www.ahead.pro/"
          target="_blank"
          title="Visit AHEAD"
          className="relative flex items-center justify-center text-black ms-1"
          onMouseEnter={() => setHovered(true)}
          onMouseLeave={() => setHovered(false)}
        >
          by
          <div className="relative w-[100px] h-[14px] mx-1">
            <AnimatePresence>
              {!hovered && (
                <motion.img
                  key="default"
                  src={ahead1}
                  alt="Ahead Logo"
                  title="Visit AHEAD"
                  className="absolute top-0 left-0 w-[100px] h-auto rounded-lg pointer-events-none"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  transition={{ duration: 0.5 }}
                />
              )}
              {hovered && (
                <motion.img
                  key={current}
                  src={images[current]}
                  alt={`Hover ${current}`}
                  title="Visit AHEAD"
                  className="absolute top-0 left-0 w-[100px] h-auto rounded-lg pointer-events-none"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  transition={{ duration: 0.5 }}
                />
              )}
            </AnimatePresence>
          </div>
        </a>
      </div>
    </>
  );
}
